module.exports = __webpack_public_path__ + "img/papel_higienico.6356042b.png";